import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import alertify from "alertifyjs";
import "../../../node_modules/alertifyjs/build/css/alertify.css";
import "../../../node_modules/alertifyjs/build/css/themes/semantic.css";
import ApiService from "../../service/httpService";

const AddLocation = ({ fetchLocation }) => {

  const cancelBtnRef = useRef(null);

  const [formData, setFormData] = useState({
    name: "",
   latitude: "",
    longitude: "",
    distance: "",
    status:"1",
  });


  const [validation, setValidation] = useState({
    name: true,
   latitude: true,
    distance: true,
    longitude: true,
    status: true,
  });

  const triggerCancel = () => {
    // This will simulate a click on the button
    if (cancelBtnRef.current) {
      cancelBtnRef.current.click();
    }
  };

  //trim input before submiting
  const trimformData = (data) => {
    const trimmedData = {};

    Object.keys(data).forEach((key) => {
      const value = (data)[key];
      trimmedData[key] = typeof value === "string" ? value.trim() : value;
    });

    return trimmedData;
  };

  //valid datation
  useEffect(() => {
    for (const key in formData) {
      const value = formData[key];
      if (
        value !== undefined &&
        value !== null &&
        value.toString().trim() !== ""
      ) {
        setValidation((prev) => ({ ...prev, [key]: true }));
      }
    }
  }, [formData]);

  const HandleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted form data:", formData);

    let Isvalid = true;
    let isEmpty = false;

    for (const key in formData) {
      const value = formData[key];
      if (
        value === undefined ||
        value === null ||
        value.toString().trim() === ""
      ) {
        console.log(key);
        Isvalid = false;
        isEmpty = true;
        setValidation((prev) => ({ ...prev, [key]: false }));
      }
    }

    alertify.set("notifier", "position", "top-right");

    if (isEmpty) {
      alertify.error("Please fill all required fields.");
      return;
    }

    else if(
    isNaN(formData.latitude) || formData.latitude < -90 || formData.latitude > 90 ) {
      alertify.error("Please enter valid latitude (-90 to 90) ");
      Isvalid = false;
      setValidation((prev) => ({ ...prev, ["latitude"]: false }));
    }
      
    else if(
      isNaN(formData.longitude) || formData.longitude < -180 || formData.longitude > 180) {
      
      alertify.error("Please enter valid longitude (-180 to 180).");
      Isvalid = false;
      setValidation((prev) => ({ ...prev, ["longitude"]: false }));
  }
      
    const trimedData = trimformData(formData);

    if (Isvalid) {
      ApiService.postPublic("post_insert_data.php?table=location&authToken=",trimedData)
        .then((data) => {
          if (data.status === "success") {
            console.log("Submission success:", data);
            alertify.success("Location added successfully!");
            resetForm();
            triggerCancel();
            fetchLocation();
          } else {
            console.log("location res",data);
            
            console.log("Submit error");
            alertify.error("Failed to submit. Please try again.");
          }
        })
        .catch((error) => {
          console.error("Submission failed:", error);
          alertify.error("Something went wrong. Please try again.");
        });
    }
  };


  //reset value
  const resetForm = () => {
    setFormData({
      name: "",
     latitude: "",
      longitude: "",
      distance: "",
      status:"1",
    });

    setValidation({
      name: true,
     latitude: true,
     longitude: true,
     distance:true,
      status: true,
    });
  };
  
  console.log(formData.status);
  
  return (
    <div
      className="modal custom-modal custom-lg-modal fade p-20"
      id="add_location"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-header border-0">
            <div className="form-header modal-header-title text-start mb-0">
              <h4 className="mb-0">
                Add New Location
              </h4>
            </div>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form onSubmit={HandleSubmit}>
            <div className="modal-body">
              <div className="row">

                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="form-label">Name </label>
                    <input
                      type="text"
                      className={`form-control ${validation.name ? "" : "input-error"
                        }`}
                      placeholder="Enter Name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    />
                  </div>
                              </div>
                              
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="form-label">Latitude </label>
                    <input
                      type="text"
                      className={`form-control ${validation.latitude ? "" : "input-error"
                        }`}
                      placeholder="Enter Latitude"
                      value={formData.latitude}
                      onChange={(e) => setFormData({ ...formData, latitude: e.target.value })}
                    />
                  </div>
                              </div>
                              
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="form-label">Longitude</label>
                    <input
                      type="text"
                      className={`form-control ${validation.longitude ? "" : "input-error"
                        }`}
                      placeholder="Enter Longitude"
                      value={formData.longitude}
                      onChange={(e) => setFormData({ ...formData, longitude: e.target.value })}
                    />
                  </div>
                              </div>
                              
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="form-label">Distance</label>
                    <input
                      type="text"
                      className={`form-control ${validation.distance ? "" : "input-error"
                        }`}
                      placeholder="Enter Distance"
                      value={formData.distance}
                      onChange={(e) => setFormData({ ...formData, distance: e.target.value })}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="d-flex align-items-center mb-3">
                    <h6 className="mb-0">status</h6>
                    <div className="status-toggle">
                      <input
                        id="access-status"
                        className="check"
                        type="checkbox"
                        checked={formData.status == "1"}
                        onChange={(e) => setFormData({ ...formData, status: e.target.checked?"1":"0" })}
                      />
                      <label
                        htmlFor="access-status"
                        className="checktoggle checkbox-bg"
                      >
                        checkbox
                      </label>
                    </div>
                  </div>
                </div>
                              
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-back cancel-btn me-2"
                ref={cancelBtnRef}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary paid-continue-btn"
              >
                Add New
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddLocation;


AddLocation.propTypes = {
  fetchLocation: PropTypes.func.isRequired,
};